<template>
  <div v-if="isEditable">
    <b-form-group
      :state="state"
      invalid-feedback="That doesn't appear to be a valid BGG thread"
    >
      <b-form-input
        placeholder="BGG thread ID # or link"
        v-model="localValue"
        :state="state"
        debounce="200"
      >
      </b-form-input>
      <template v-slot:description>
        <span v-if="loading">
          <b-spinner small label="Checking BGG link..."></b-spinner> Checking
          BBG link...
        </span>
        <span v-else>
          (Optional) link to a discussion on BoardGameGeek
        </span>
      </template>
      <template v-slot:valid-feedback>
        <strong>Preview: </strong>
        <a
          :href="`https://www.boardgamegeek.com/thread/${threadID}`"
          target="_blank"
          >{{ threadTitle }}
        </a>
      </template>
    </b-form-group>
  </div>
  <div v-else>
    <a
      :href="`https://www.boardgamegeek.com/thread/${threadID}`"
      target="_blank"
      >{{ threadTitle }}</a
    >
  </div>
</template>

<script>
import axios from "axios";
import xml2js from "xml2js";

export default {
  name: "BGGLink",
  data() {
    return {
      threadTitle: "",
      loading: false,
      previewError: false
    };
  },
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    isEditable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    threadID() {
      return this.extractThreadID(this.value);
    },
    state() {
      if (this.value === "" || this.loading) return null;
      if (this.threadID && !this.previewError) {
        return true;
      }
      return false;
    },
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    extractThreadID(val) {
      const re = /^(((((https?:\/\/)?(www\.)?boardgamegeek.com)?\/)?thread)?\/)?(?<threadID>\d+)(\/(.*)?)?$/;
      const match = re.exec(val);
      return match ? match.groups.threadID : null;
    }
  },
  watch: {
    threadID: {
      immediate: true,
      handler: async function(val) {
        if (val) {
          this.threadTitle = "";
          this.loading = true;
          this.previewError = false;
          const response = await axios.get(
            `https://www.boardgamegeek.com/xmlapi2/thread`,
            { params: { id: val } }
          );
          this.loading = false;
          const parsedThread = await xml2js.parseStringPromise(response.data);
          if (parsedThread.thread) {
            this.threadTitle = parsedThread.thread.subject[0];
            return;
          }
          this.previewError = true;
        }
        this.threadTitle = "";
      }
    }
  }
};
</script>
